import React, { useState, Component } from "react";
import { Layout, Breadcrumb } from 'antd';
const { Footer } = Layout;
const FooterCmp = () => {
    return(
        <Footer style={{ textAlign: 'center' }}>Sparkle Express ©2021 Created by Sparkles Int.</Footer>
    )
}

export default FooterCmp